import React from 'react';
import { Box, Typography } from '@mui/material';

interface PasswordStrengthIndicatorProps {
  password: string;
}

interface Rule {
  label: string;
  met: boolean;
}

function getScore(password: string): number {
  let score = 0;
  if (password.length >= 8) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/\d/.test(password)) score++;
  if (password.length >= 12) score++;
  return score;
}

const SEGMENT_COLORS = ['error.main', 'warning.main', 'info.main', 'success.main'];

const PasswordStrengthIndicator: React.FC<PasswordStrengthIndicatorProps> = ({ password }) => {
  if (!password) return null;

  const score = getScore(password);

  const rules: Rule[] = [
    { label: 'ตัวอักษร 8 ตัวขึ้นไป', met: password.length >= 8 },
    { label: 'ตัวพิมพ์ใหญ่', met: /[A-Z]/.test(password) },
    { label: 'ตัวเลข', met: /\d/.test(password) },
  ];

  return (
    <Box sx={{ mt: 1 }}>
      {/* Strength bar */}
      <Box sx={{ display: 'flex', gap: 0.5, mb: 1 }}>
        {[0, 1, 2, 3].map((i) => (
          <Box
            key={i}
            sx={{
              flex: 1,
              height: 4,
              borderRadius: 2,
              bgcolor: i < score ? SEGMENT_COLORS[score - 1] : 'action.disabledBackground',
              transition: 'background-color 0.2s',
            }}
          />
        ))}
      </Box>

      {/* Rule checklist */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
        {rules.map((rule) => (
          <Typography
            key={rule.label}
            variant="caption"
            sx={{ color: rule.met ? 'success.main' : 'text.secondary' }}
          >
            {rule.met ? '\u2713' : '\u2717'} {rule.label}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default PasswordStrengthIndicator;
